//env variables
export const APPLOZIC_KEY = process.env.REACT_APP_APPLOZIC_KEY;
export const APPLOZIC_PASSWORD = process.env.REACT_APP_APPLOZIC_PASSWORD;
//constants
export const APPLOZIC_BASE_URL = "https://apna.applozic.com";
export const APPLOZIC_WEBSOCKET_URL = "https://apna-socket.applozic.com";
